import styled from "styled-components";
export const RecentReviewsWrapper = styled.div`
    color: var(--gray);
    font-size: 16px;
    line-height: 20px;
    font-weight: 300;
    .review-wrap {
        margin-bottom: 20px;
        border-bottom: 1px solid #ececec;
        &:nth-last-child(1) {
            border-bottom: none;
        }
    }
    .user-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        margin-bottom: 20px;
        color: var(--text-color);
        .user-title {
            display: flex;
            align-items: center;
            gap: 10px;
            strong {
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
            img {
                width: 30px;
                height: 30px;
            }
        }
    }
    .rating-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
        .stars {
            display: flex;
            align-items: flex-start;
            gap: 2px;
            svg {
                width: 18px;
                height: 18px;
                color: ${({theme}) => theme?.light?.primary};
            }
        }
    }
`;
